import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import CMSGallery from "../components/CMSGallery";
import { IMAGES, VANDREFOLDE_TEXT } from "../data/content";

export default function Vandrefolde() {
  return (
    <>
      <SEO
        title="Vandrefolde & Paddock Paradise"
        description="Inspiration til vandrefolde og stisystemer for heste. Lær hvordan mere bevægelse 24/7, ad libitum hø og foderstationer giver stærke hove og sundere heste."
      />

      {/* Header Banner */}
      <section className="bg-forest-900 text-white py-14 lg:py-18 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,format=auto,quality=80/assets/811d3c72-b547-489f-a70d-a64fabca8eaa/bare-graes-fold.jpg"
            alt="Græsmark og fold"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-3">
          <span className="text-xs font-bold uppercase tracking-wider text-emerald-400">
            Foldmiljø & Naturlig Bevægelse
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-sand-50">
            Vandrefolde
          </h1>
          <p className="text-sand-200 max-w-2xl text-base leading-relaxed">
            {VANDREFOLDE_TEXT.title}
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-sand-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-7 space-y-4">
              <span className="text-xs font-bold uppercase tracking-wider text-earth-700">
                Foldkonceptet
              </span>
              <h2 className="text-2xl sm:text-3xl font-bold text-forest-900 leading-snug">
                {VANDREFOLDE_TEXT.title}
              </h2>
              <p className="text-charcoal-700 leading-relaxed text-base">
                {VANDREFOLDE_TEXT.p1}
              </p>
            </div>

            <div className="md:col-span-5">
              <div className="rounded-2xl overflow-hidden border border-sand-300 shadow-md">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,format=auto,quality=80/assets/811d3c72-b547-489f-a70d-a64fabca8eaa/eeeee.png"
                  alt="Vandrefold med heste i Danmark"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>

          {/* Hvorfor vandrefold og hvad gør det ved hestene? */}
          <div className="bg-white p-6 sm:p-8 rounded-2xl border border-sand-300 shadow-xs space-y-5">
            <h3 className="text-2xl font-bold text-forest-900">
              {VANDREFOLDE_TEXT.whyTitle}
            </h3>

            <p className="text-charcoal-700 leading-relaxed text-base">
              {VANDREFOLDE_TEXT.p2}
            </p>

            <p className="text-charcoal-700 leading-relaxed text-base">
              {VANDREFOLDE_TEXT.p3}
            </p>

            <div className="p-5 bg-sand-50 rounded-xl border border-sand-200 space-y-2">
              <h4 className="font-bold text-forest-900 text-sm flex items-center gap-2">
                <i className="fa-solid fa-horse text-emerald-700"></i>
                Egne erfaringer fra Metteline Hjorth:
              </h4>
              <p className="text-sm text-charcoal-800 leading-relaxed">
                {VANDREFOLDE_TEXT.p4}
              </p>
            </div>
          </div>

          {/* Big CMS Gallery */}
          <div className="pt-6 border-t border-sand-300">
            <CMSGallery gallerySlug="vandrefolde" title="Stort Galleri: Vandrefolde & Foldmiljø" />
          </div>

          {/* Consultation Box */}
          <div className="bg-forest-900 text-white p-8 rounded-2xl flex flex-col sm:flex-row items-center justify-between gap-6 shadow-md">
            <div>
              <h3 className="text-xl font-bold text-sand-50">Ønsker du rådgivning om indretning af din fold?</h3>
              <p className="text-sm text-sand-200 mt-1">Jeg rådgiver gerne om praktiske løsninger tilpasset din ejendom i Jylland.</p>
            </div>
            <Link
              to="/kontakt"
              className="px-6 py-3 bg-forest-700 hover:bg-forest-600 text-white font-bold text-sm rounded-xl transition-colors cursor-pointer shrink-0"
            >
              Kontakt mig
            </Link>
          </div>

        </div>
      </section>
    </>
  );
}
